var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockLightGreenNoBgLightGreenBorderRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "#08AA15",
    stroke: "#333541"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 14C22 15.5823 21.5308 17.129 20.6518 18.4446C19.7727 19.7602 18.5233 20.7855 17.0615 21.391C15.5997 21.9965 13.9911 22.155 12.4393 21.8463C10.8874 21.5376 9.46197 20.7757 8.34315 19.6569C7.22433 18.538 6.4624 17.1126 6.15372 15.5607C5.84504 14.0089 6.00346 12.4003 6.60896 10.9385C7.21446 9.47672 8.23985 8.22729 9.55544 7.34824C10.871 6.46919 12.4177 6 14 6V14H22Z",
    fill: "white",
    stroke: "#010311"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14C22 12.9494 21.7931 11.9091 21.391 10.9385C20.989 9.96793 20.3997 9.08601 19.6569 8.34315C18.914 7.60028 18.0321 7.011 17.0615 6.60896C16.0909 6.20693 15.0506 6 14 6L14 14H22Z",
    fill: "#D0D3E2",
    stroke: "#010311"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockLightGreenNoBgLightGreenBorderRounded);
export default __webpack_public_path__ + "static/media/clockLightGreenNoBgLightGreenBorderRounded.542459e0ac519a09cfe8a3d73aa87440.svg";
export { ForwardRef as ReactComponent };